import React from 'react';
import PropTypes from 'prop-types';

import BaseBillingInformation from 'UserRegistration/components/RegistrationSteps/BillingInformation/BaseBillingInformation';

/**
 * Displays the Public Registration version of the Billing Information section.
 * 
 * @param {object} props 
 */
function PublicBillingInformation(props) {

    return (

        <BaseBillingInformation
            {...props}
            isAddContactContext={false}
        />

    );

}

PublicBillingInformation.propTypes = {
    /** A reference to the Formik component. */
    formikRef: PropTypes.any,
    /** The total number of configurable sections currently loaded in the instance of UserRegistration. */
    sectionCount: PropTypes.number,
    /** The position of this section in relation to other sections in the entire instance of UserRegistration. */
    sectionNumber: PropTypes.number
};

export default PublicBillingInformation;